:host {
  display: block;
}

div {
  align-items: center;
  background: var(--ui-color-text);
  border-radius: var(--ui-border-radius-md);
  display: flex;
  justify-content: flex-start;
  margin: 0;
  padding: 0 var(--ui-space-xs);
}

div.light {
  background: var(--search-bar-light-bg);
  border: 1px solid var(--search-bar-light-border);
  color: var(--ui-color-dark);
}

div.dark {
  background: var(--ui-color-gray-1);
  color: var(--ui-color-text);
}

input {
  background: transparent;
  border: none;
  caret-color: currentcolor; /* To fix caret in Safari mobile for light and dark themes */
  color: inherit;
  flex: 1;
  font-size: var(--ui-font-size-base);
  font-weight: var(--ui-font-weight-regular);
  letter-spacing: inherit;
  margin: 0;
  outline: none;
  padding: 0;
  width: 100%;
}

div:focus-within {
  outline: 2px solid var(--ui-color-focus);
  outline-offset: 2px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  appearance: none;
}

/* Fix for autofill background */
input:-webkit-autofill,
input:-webkit-autofill:focus {
  transition:
    background-color 600000s 0s,
    color 600000s 0s;
}

input::placeholder {
  /* --search-bar-placeholder-color: override hook for a11y high-contrast mode (defined in tokens/a11y.css) */
  color: var(--search-bar-placeholder-color);
}

.search-label {
  position: absolute;
  clip-path: inset(50%);
  overflow: hidden;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  white-space: nowrap;
}

.search-input {
  height: 40px;
}

.search-icon {
  height: var(--ui-font-size-base);
  line-height: 1;
  margin-right: var(--ui-space-xs);
  padding: var(--ui-space-xxs);
  width: var(--ui-font-size-base);
}

.spinner-icon {
  height: var(--ui-font-size-base);
  line-height: 1;
  margin-right: var(--ui-space-xs);
  padding: var(--ui-space-xxs);
  width: var(--ui-font-size-base);
}

.clear-icon {
  cursor: pointer;
  height: var(--ui-font-size-base);
  line-height: 1;
  margin-left: var(--ui-space-xs);
  padding: var(--ui-space-xxs);
  width: var(--ui-font-size-base);
}
